'use client';

import { use, useMemo } from 'react';
import { getOptionsFromSearchParams } from '../../utils/product-options';
import { useProduct } from '../use-product';
import { useSelectionStore } from './use-selection-store';

/**
 * Internal-only private hook.
 * Resolves the page's searchParams promise and returns resolved selected options.
 * Hooks that depend on this require <Suspense>.
 */
export function useResolvedOptions() {
  const { productData, settings } = useProduct();
  const selectionStore = useSelectionStore();

  const resolvedSearchParams = use(selectionStore.searchParams);

  // We're moving away from useMemo but keep this memoized for now
  const urlSelectedOptions = useMemo(
    () =>
      getOptionsFromSearchParams(productData, settings, resolvedSearchParams),
    [productData, settings, resolvedSearchParams]
  );

  // User-picked override wins. If none is set yet, fall back to URL options.
  const selectedOptions =
    selectionStore.selectedOptionsOverride ?? urlSelectedOptions;

  return { searchParams: resolvedSearchParams, selectedOptions };
}
